import { useQuery } from '@tanstack/react-query';

import { assetKeys } from '@/shared/lib/query/queryKeys';

import { fetchContainerFiles } from '@/features/asset-detail';
import type { FilesResponse } from '@/features/asset-detail';

export const useContainerFiles = (containerFqn: string, path: string = '', enabled: boolean = true) => {
  return useQuery<FilesResponse | null>({
    queryKey: assetKeys.containerFiles(containerFqn, path),
    queryFn: async () => {
      if (!enabled) {
        return null;
      }
      return fetchContainerFiles(containerFqn, path);
    },
    enabled: enabled && !!containerFqn,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
};
